// ── SiteScope Design Tokens — v37 canonical design system ──────────────────
// Source: sitescope-mobile-mockup-v37-final.jsx
// These are the single source of truth for colors, typography, and patterns.

export const COLORS = {
  bg:          "#081525",
  card:        "#0a1b36",
  cardBorder:  "#30404e",
  cardHover:   "#122a44",
  amber:       "#c0a060",
  amberDark:   "#8a7040",
  text:        "#f0f2f6",
  textMuted:   "#a8b8cc",
  textDim:     "#6a80a0",
  green:       "#5aba6a",
  greenDark:   "#1a3a2a",
  orange:      "#d49060",
  orangeDark:  "#8a5840",
  red:         "#ef4444",
  blue:        "#3b82f6",
  blueDark:    "#1e3a5f",
  purple:      "#a855f7",
  teal:        "#14b8a6",
  navBg:       "#061020",
  proBadge:    "#c0a060",
};

export const STATUS_COLORS = {
  Lodged:                              { bg: "#1a2840", text: "#a8b8cc", dot: "#a8b8cc" },
  Submitted:                           { bg: "#1a2840", text: "#a8b8cc", dot: "#a8b8cc" },
  "In Progress":                       { bg: "#1a2840", text: "#a8b8cc", dot: "#a8b8cc" },
  "Pending Lodgement":                 { bg: "#1a2840", text: "#a8b8cc", dot: "#a8b8cc" },
  "Under Assessment":                  { bg: "#142e50", text: "#76c9f1", dot: "#76c9f1" },
  "On Exhibition":                     { bg: "#2a2418", text: "#d49060", dot: "#d49060" },
  Approved:                            { bg: "#142e20", text: "#5aba6a", dot: "#5aba6a" },
  Determined:                          { bg: "#142e20", text: "#5aba6a", dot: "#5aba6a" },
  "Deferred Commencement":             { bg: "#142e20", text: "#5aba6a", dot: "#5aba6a" },
  "CDC Accepted":                      { bg: "#142e20", text: "#5aba6a", dot: "#5aba6a" },
  Refused:                             { bg: "#2e1a20", text: "#d06868", dot: "#d06868" },
  Rejected:                            { bg: "#2e1a20", text: "#d06868", dot: "#d06868" },
  "CDC Rejected":                      { bg: "#2e1a20", text: "#d06868", dot: "#d06868" },
  Withdrawn:                           { bg: "#1a2840", text: "#6a80a0", dot: "#6a80a0" },
  "Additional Information Requested":  { bg: "#2a2418", text: "#d49060", dot: "#d49060" },
  Returned:                            { bg: "#2a2418", text: "#d49060", dot: "#d49060" },
  Open:                                { bg: "#1a2840", text: "#a8b8cc", dot: "#a8b8cc" },
};

export const CATEGORY_COLORS = {
  RESIDENTIAL:  "#76c9f1",
  COMMERCIAL:   "#c0a060",
  "MIXED USE":  "#b0a0c8",
  INDUSTRIAL:   "#50b0a0",
  RURAL:        "#5aaa6a",
  SUBDIVISION:  "#a0b0d0",
  "DUAL OCC":   "#c09868",
  OTHER:        "#6a80a0",
};

export const PIPELINE_COLORS = {
  watching:  { bg: "#1a2840", text: "#a8b8cc", dot: "#a8b8cc", label: "Watching"  },
  contacted: { bg: "#1e3a5f", text: "#3b82f6", dot: "#3b82f6", label: "Contacted" },
  quoted:    { bg: "#2a2418", text: "#c0a060", dot: "#c0a060", label: "Quoted"    },
  won:       { bg: "#142e20", text: "#5aba6a", dot: "#5aba6a", label: "Won"       },
  lost:      { bg: "#2e1a20", text: "#d06868", dot: "#d06868", label: "Lost"      },
};

// Shared card shadow
export const CARD_SHADOW = "0 2px 12px rgba(0,0,0,0.4), 0 1px 3px rgba(0,0,0,0.25)";

// Font stack
export const FONT = "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif";

// Google font import (add to global CSS or App component)
export const FONT_IMPORT = "@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap');";
